/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-10 13:57:25
 */
import { exportNames, applyNames } from './join';
import { exit } from './exit';

export default [
  { name: '项目入驻', childMenu: [exportNames, applyNames] },
  { name: '项目退出', childMenu: [exit] }
];
